module.exports = __webpack_public_path__ + "img/do.3e95cfd0.svg";